import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import { StyledIntegrationTag } from "../styles";

export const StyledMultipleAccountsTag = styled(StyledIntegrationTag)`
    background-color: ${colorsPalettes.orange["100"]};
    padding: 6px 16px;

    & span {
        color: ${colorsPalettes.orange["500"]};
    }

    &:hover {
        background-color: ${colorsPalettes.orange["200"]};
    }
`;
